import { useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);

    // Dynamic Title per route
    const titles: Record<string, string> = {
      "/": "FormaCode Technologies — Build. Automate. Innovate.",
      "/about": "About Us — FormaCode Technologies",
      "/services": "Services — FormaCode Technologies",
      "/services/website-development": "Website Development — FormaCode Technologies",
      "/services/ai-automation": "AI Agents & Automation — FormaCode Technologies",
      "/services/seo-marketing": "SEO & Digital Marketing — FormaCode Technologies",
      "/services/video-editing": "Video Editing — FormaCode Technologies",
      "/services/social-analytics": "Social Media Analytics — FormaCode Technologies",
      "/services/hosting": "Hosting & Domain — FormaCode Technologies",
      "/services/meta-ads": "Meta Ads — FormaCode Technologies",
      "/portfolio": "Portfolio & Case Studies — FormaCode Technologies",
      "/contact": "Contact & Project Inquiry — FormaCode Technologies",
      "/privacy": "Privacy Policy — FormaCode Technologies",
      "/terms": "Terms & Conditions — FormaCode Technologies",
      "/cookies": "Cookie Policy — FormaCode Technologies",
      "/admin/login": "Admin Login — FormaCode Technologies",
      "/admin/dashboard": "Admin Dashboard — FormaCode Technologies",
    };

    document.title = titles[pathname] || "FormaCode Technologies";
  }, [pathname]);

  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;

